import { useEffect, useRef, useState } from "react"
import "./TrustSection.css"

function TrustSection(){

const [boutiques,setBoutiques] = useState(0)
const [orders,setOrders] = useState(0)
const [designs,setDesigns] = useState(0)

const sectionRef = useRef(null)
const started = useRef(false)

useEffect(()=>{

const observer = new IntersectionObserver((entries)=>{

if(entries[0].isIntersecting && !started.current){

started.current = true

let b = 0
let o = 0
let d = 0

const interval = setInterval(()=>{

b += 10
o += 200
d += 5

if(b >= 500) b = 500
if(o >= 10000) o = 10000
if(d >= 120) d = 120

setBoutiques(b)
setOrders(o)
setDesigns(d)

if(b === 500 && o === 10000 && d === 120){
clearInterval(interval)
}

},40)

}

},{threshold:0.5})

observer.observe(sectionRef.current)

return ()=>observer.disconnect()

},[])

return(

<div ref={sectionRef} className="trustSection">

<h2 className="trustTitle">
Trusted by Designers & Boutiques Across India
</h2>

<p className="trustSub">
Premium lace, gota patti and fashion accessories trusted by fashion boutiques.
</p>

<div className="trustStats">

<div className="trustCard">
<h3>{boutiques}+</h3>
<p>Boutiques</p>
</div>

<div className="trustCard">
<h3>{orders}+</h3>
<p>Orders Delivered</p>
</div>

<div className="trustCard">
<h3>{designs}+</h3>
<p>Lace Designs</p>
</div>

</div>

</div>

)

}

export default TrustSection